<template>
  <div class="container-fluid mt--9">
    <div class="row">
      <div class="col">
        <div class="card shadow">
          <div class="card-header bg-transparent">
            <h3 class="mb-0">Pesquisa Avançada</h3>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <tabs>
                  <tab-pane title="Pesquisar por texto">
                    <div class="row">
                      <div class="col-12">
                        <p class="description font-weight-400">Pesquise por publicações
                          informando o intervalo entre duas datas e o texto ou parte do
                          texto que você
                          deseja encontrar.</p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <VueCtkDateTimePicker
                            :range="true"
                            :auto-close="true"
                            :no-weekends-days="true"
                            :no-button="true"
                            :custom-shortcuts="customShortcuts"
                            :max-date="maxDate"
                            label="Selecione a data"
                            format="YYYY-MM-DD"
                            formatted="DD/MM/YYYY"
                            v-model="filtro.dia_data_publicacao"></VueCtkDateTimePicker>
                      </div>
                    </div>
                    <div class="row mt-3">
                      <div class="col-12">
                        <base-input v-model="filtro.texto"
                                    @keyup.enter.native="pesquisar('texto')"
                                    placeholder="Informe o texto ou parte do texto que deseja encontrar">
                        </base-input>
                      </div>
                    </div>
                    <div class="row mt-3">
                      <div class="col-12 text-center">
                        <p v-show="httpAction"><i class="fas fa-spinner fa-pulse"></i>
                          Pesquisando...</p>
                        <base-button v-show="!httpAction"
                                     :disabled="!filtro.dia_data_publicacao || !filtro.texto || filtro.texto.length < 3"
                                     block icon="fas fa-search"
                                     @click="pesquisar('texto')"
                                     type="default">Pesquisar
                        </base-button>
                      </div>
                    </div>
                    <secao-resultado :resultado="result.secao"></secao-resultado>
                  </tab-pane>
                  <tab-pane title="Edição">
                    <div class="row">
                      <div class="col-12">
                        <p class="description font-weight-400">Pesquise por diário
                          informando o número da edição.</p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <base-input v-model="filtro.dia_numero"
                                    @keyup.enter.native="pesquisar('edicao')"
                                    placeholder="Informe o número da edição">
                        </base-input>
                      </div>
                    </div>
                    <div class="row mt-3">
                      <div class="col-12 text-center">
                        <p v-show="httpAction"><i class="fas fa-spinner fa-pulse"></i>
                          Pesquisando...</p>
                        <base-button v-show="!httpAction" block icon="fas fa-search"
                                     @click="pesquisar('edicao')"
                                     type="default">Pesquisar
                        </base-button>
                      </div>
                    </div>
                    <edicao-resultado :resultado="result.edicao"></edicao-resultado>
                  </tab-pane>
                  <tab-pane title="Seção ou título">
                    <div class="row">
                      <div class="col-12">
                        <p class="description font-weight-400">Pesquise por diário
                          selecionando a seção e/ou informando o título ou parte do título
                          da publicação.</p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <div class="form-group">
                          <label for="tit_descricao">Selecione a seção</label>
                          <select v-model="filtro.tit_codigo" class="form-control"
                                  id="tit_descricao">
                            <option selected v-bind:value="null">TODAS</option>
                            <option v-for="s in secoes" v-bind:value="s.tit_codigo" :key="s.tit_codigo">
                              {{ s.tit_descricao }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <base-input v-model="filtro.pub_descricao"
                                    @keyup.enter.native="pesquisar('secao')"
                                    placeholder="Informe o título ou parte do título da publicação">
                        </base-input>
                      </div>
                    </div>
                    <div class="row mt-3">
                      <div class="col-12 text-center">
                        <p v-show="httpAction"><i class="fas fa-spinner fa-pulse"></i>
                          Pesquisando...</p>
                        <base-button v-show="!httpAction"

                                     block icon="fas fa-search"
                                     @click="pesquisar('secao')"
                                     type="default">Pesquisar
                        </base-button>
                      </div>
                    </div>
                    <secao-resultado :resultado="result.secao"></secao-resultado>
                  </tab-pane>
                </tabs>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import moment from 'moment-timezone'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import {getSecoes} from '@/api/inicio'
import {getDiarios} from '@/api/pesquisa';
import EdicaoResultado from "./EdicaoResultado";
import SecaoResultado from "./SecaoResultado";

Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);
export default {
  name: "PesquisaAntiga",
  components: {
    EdicaoResultado,
    SecaoResultado
  },
  data() {
    return {
      maxDate: moment().format('YYYY-MM-DD HH:mm'),
      customShortcuts: [
        {key: 'thisWeek', label: 'Esta semana', value: 'isoWeek'},
        {key: 'lastWeek', label: '(-) Semana', value: '-isoWeek'},
        {key: 'last7Days', label: '(-) 7 dias', value: 7},
        {key: 'last30Days', label: '(-) 30 dias', value: 30},
        {key: 'thisMonth', label: 'Este mês', value: 'month'},
        {key: 'lastMonth', label: '(-) Mês', value: '-month'},
        {key: 'thisYear', label: 'Este ano', value: 'year'},
        {key: 'lastYear', label: '(-) Ano', value: '-year'}
      ],
      httpAction: false,
      secoes: [],
      filtro: {
        dia_data_publicacao: null,
        texto: '',
        dia_numero: '',
        tit_codigo: null,
        pub_descricao: ''
      },
      result: {
        edicao: null,
        secao: null
      }
    }
  },
  methods: {
    listSecoes() {
      getSecoes().then(response => {
        if (response.status) {
          this.secoes = response.data;
        }
      }).catch(error => {
        //console.log(error);
      }).finally(finalit => {

      })
    },
    pesquisar(tipo) {
      this.httpAction = true;
      getDiarios(tipo, this.filtro).then(response => {
        if (tipo === 'edicao') {
          this.result.edicao = response
        } else if (tipo === 'secao' || tipo === 'texto') {
          this.result.secao = response
        }
      }).catch(error => {
      }).finally(finalit => {
        this.httpAction = false;
      })
    },
  },
  created() {
    this.listSecoes();
  }
};
</script>
<style></style>
